import React, { useState, useRef, useLayoutEffect } from 'react'
import PropTypes from 'prop-types'
import { renderRichText, useInnerBlocks } from 'gutenberg/utils'
import Draggable from 'react-draggable'
import {
  MouseParallaxContainer,
  MouseParallaxChild,
} from 'react-parallax-mouse'

import {
  Wrapper,
  CircleWrap,
  PageHeaderWrapper,
  Title,
  Text,
  Content,
  SideContent,
  Image,
  Decor,
  BGImage,
} from './custom.styled'
import { Container, Row, Col } from '../../styled-components/Layout'

const PageHeader = ({
  isEditor = false,
  children,
  title,
  text,
  align,
  image,
  decor_image,
  decor_position,
  overlapBottom,
  setAttributes,
}) => {
  const { InnerBlocks, ref } = useInnerBlocks(children, 'div')
  const refWrapper = useRef(null)
  const [width, setWidth] = useState(0)
  const [height, setHeight] = useState(0)

  useLayoutEffect(() => {
    setWidth(refWrapper.current.clientWidth)
    setHeight(refWrapper.current.clientHeight)
  }, [])

  return (
    <Wrapper data-align={align} overlapBottom={overlapBottom}>
      <CircleWrap>
        <PageHeaderWrapper
          ref={refWrapper}
          className={'dhsv-page-header'}
          isEditor={isEditor}
        >
          <Image>
            {isEditor ? (
              <>
                {image.url && (
                  <BGImage src={image.url} alt={image.alt || image.title} />
                )}
                {decor_image.url && (
                  <Draggable
                    onStop={(e, data) => {
                      setAttributes({
                        decor_position: {
                          transform: data.node.style.transform,
                          x: data.x,
                          y: data.y,
                        },
                      })
                    }}
                    position={decor_position}
                  >
                    <Decor
                      src={decor_image.url}
                      alt={decor_image.alt || decor_image.title}
                      isEditor={isEditor}
                    />
                  </Draggable>
                )}
              </>
            ) : (
              <MouseParallaxContainer useWindowMouseEvents={true}>
                {image.url && (
                  <MouseParallaxChild
                    factorX={0.01}
                    factorY={0.01}
                    inverted={true}
                    className={'parallax-bg'}
                  >
                    <BGImage src={image.url} alt={image.alt || image.title} />
                  </MouseParallaxChild>
                )}
                {decor_image.url && (
                  <MouseParallaxChild
                    factorX={0.03}
                    factorY={0.02}
                    inverted={true}
                    className={'parallax-decor'}
                  >
                    <Decor
                      src={decor_image.url}
                      alt={decor_image.alt || decor_image.title}
                      style={{
                        top: `${Math.round(
                          (decor_position.y / height) * 100
                        )}%`,
                        left: `${Math.round(
                          (decor_position.x / width) * 100
                        )}%`,
                      }}
                      isEditor={isEditor}
                    />
                  </MouseParallaxChild>
                )}
              </MouseParallaxContainer>
            )}
          </Image>
          <Container>
            <Row align="flex-end" mobileDirection="wrap">
              <Col size="6" mobileSize="100%">
                <Content>
                  {renderRichText(title, Title)}
                  {renderRichText(text, Text)}
                </Content>
              </Col>
              <Col size="6" mobileSize="100%">
                <SideContent ref={ref}>{InnerBlocks}</SideContent>
              </Col>
            </Row>
          </Container>
        </PageHeaderWrapper>
      </CircleWrap>
    </Wrapper>
  )
}

PageHeader.propTypes = {
  isMobile: PropTypes.bool,
  children: PropTypes.string,
  title: PropTypes.string,
  text: PropTypes.string,
  align: PropTypes.string,
  isEditor: PropTypes.bool,
  image: PropTypes.object,
  decor_image: PropTypes.object,
  decor_position: PropTypes.object,
  overlapBottom: PropTypes.bool,
  setAttributes: PropTypes.func,
}

export default PageHeader
